import { ApiRequestor } from '@madbox/api_requestor';
import { ApiRequestor2 } from '@madbox/api_requestor2';
import { SquirtleSquadApiClient } from '@madbox/squirtle_squad_api_client';
import Cookies from 'universal-cookie';
import MemberManager from '@madbox/react_member_manager/manager';

const cookies = new Cookies();

const SessionManager = {
  redirect: true,
  authorizations: [],
  /**
   * @type {SquirtleSquadApiClient}
   */
  squirtleSquadApiClient: null,

  async initRequest(payload) {
    try {
      SessionManager.init();
      const isLoggedIn = SessionManager.isLoggedIn();
      if (!isLoggedIn && SessionManager.redirect && window.location.hostname !== 'admin.madbox.io') {
        const url = payload && payload.config && payload.config.url ? payload.config.url : 'https://admin.madbox.io';
        window.location.href = `${url}?redirect=${encodeURIComponent(window.location.href)}`;
        return;
      }
      if (!isLoggedIn) {
        return;
      }
      const profile = payload.customGetProfile
        ? await payload.customGetProfile()
        : await MemberManager.get({ withTeams: true });
      const headerMenu = payload.customGetMenu ? await payload.customGetMenu() : await SessionManager.getHeaderMenu();

      return {
        profile: profile,
        authorizations: SessionManager.authorizations,
        headerMenu: headerMenu,
      };
    } catch (e) {
      return e;
    }
  },
  init: (squirtleSquadApiClient) => {
    SessionManager.squirtleSquadApiClient = squirtleSquadApiClient || SquirtleSquadApiClient.instance;

    let token = SessionManager.getToken();

    if (token) {
      SessionManager.setApiRequestorToken(token);
      SessionManager.saveToken(token);
    }

    ApiRequestor.instance.setTokenUpdateCallback((token) => {
      SessionManager.saveToken(token);
    });
  },
  /**
   * @param {{mail: string, password: string} | {googleIdToken: string}} options
   * @returns
   */
  async loginRequest(options) {
    await SessionManager.login(options);
    const profile = await MemberManager.get({ withTeams: true });
    const headerMenu = await SessionManager.getHeaderMenu();
    return { profile: profile, authorizations: SessionManager.authorizations, headerMenu: headerMenu };
  },
  /**
   * @param {{mail: string, password: string} | {googleIdToken: string}} options
   * @returns
   */
  login: (options) => {
    return SessionManager.squirtleSquadApiClient.Member.login(options).then((token) => {
      SessionManager.saveToken(token);
    });
  },
  logout: (redirect) => {
    cookies.remove('token', { domain: 'madbox.io' });
    window.localStorage.removeItem('token');
    SessionManager.squirtleSquadApiClient.apiRequestor.removeToken();
    ApiRequestor2.instance.setToken('');
    if (typeof redirect !== 'undefined' ? redirect : SessionManager.redirect) {
      window.location.href = 'https://admin.madbox.io';
    }
  },
  isLoggedIn: () => {
    let token = SessionManager.getToken();
    return !!token;
  },
  setApiRequestorToken: (token) => {
    SessionManager.squirtleSquadApiClient.apiRequestor.setToken(token);
    ApiRequestor2.instance.setToken(token);
  },
  saveToken: (token) => {
    cookies.set('token', token, { domain: 'madbox.io' });
    window.localStorage.setItem('token', token);

    const base64Url = token.split('.')[1];
    const payload = JSON.parse(window.atob(base64Url));
    SessionManager.authorizations = payload.authorizations;
  },
  getToken: () => {
    const params = new URL(window.location.href).searchParams;
    const urlToken = params.get('token');
    if (urlToken) {
      SessionManager.saveToken(urlToken);
      // remove token from url for security reasons
      params.delete('token');
      const strParams = params.toString();
      window.history.replaceState(
        null,
        '',
        window.location.pathname + (strParams ? '?' + strParams : '') + window.location.hash
      );
      return urlToken;
    }

    const cookieToken = cookies.get('token');
    if (cookieToken) return cookieToken;

    const localStorageCookie = window.localStorage.getItem('token');
    if (localStorageCookie) return localStorageCookie;

    return null;
  },
  getHeaderMenu: () => {
    return SessionManager.squirtleSquadApiClient.ApiService.getHeader();
  },
};

export default SessionManager;
